import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Button, RoutePath } from '../../../../../shared/model/enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { AddEditManufacturerComponent } from '../../../../admin/look-up-tables/pop-ups/multi-level-list-popups/add-edit-manufacturer/add-edit-manufacturer.component';
import { ModalPopupSize } from '../../../../../shared/model/common.model';
import { AddEditPartComponent } from '../add-edit-part/add-edit-part.component';
import { PartsListService } from '../../pages/parts-list/parts-list.service';
import { FilterCheckList } from '../../../../crm/companies/pages/companies/companies.model';
import { StingToDateService } from '../../../../../shared/services/stringToDate.service';
import { VendorPartsLibraryService } from '../../../vendor-parts-library/pages/vendor-parts-library/vendor-parts-library.service';
import { ActivityTabService } from '../../../../crm/companies/pages/company-info-tabs/activity-tab/activity-tab.service';
import { CompaniesService } from '../../../../crm/companies/pages/companies/companies.service';
import { Router } from '@angular/router';
import { OemExcessService } from '../../../oem-excess/pages/oem-excess/oem-excess.service';

@Component({
  selector: 'app-add-edit-vendor-part',
  templateUrl: './add-edit-vendor-part.component.html',
  styleUrls: ['./add-edit-vendor-part.component.scss']
})
export class AddEditVendorPartComponent implements OnInit {
  enumButtonName = Button;
  title
 @Input() data:any ={}
 formModel:any ={}
expirationDate
getAllDropdown: any = {};
filterCheckList = new FilterCheckList();
allContactList:any;
  constructor(
    public activeModal: NgbActiveModal,
    public toaster: ToastrService,
    public renderer: Renderer2,
    public sendDataService: SendDataService,
    public partsListService: PartsListService,
    public stringToDateService: StingToDateService,
    public vplService: VendorPartsLibraryService,
    public activityTabService : ActivityTabService, 
    public companiesService   : CompaniesService,
    public oemExcessService : OemExcessService,
    private router: Router,
  ) {
    if(this.router.url === `${RoutePath.VPLINFO_ROUTEPATH}${this.companiesService?.id}`){
      this.formModel.vendorId = this.companiesService?.id }
    else if (this.router.url === `${RoutePath.OEMMANAGERINFO_ROUTEPATH}${this.companiesService?.id}`){
      this.formModel.companyId = this.companiesService?.id
    }
   }

  ngOnInit(): void {
    if (this.data?.id) {
      if(!this.data?.OEMExcessPopup){
      this.vendorPartById(this.data.id);
    } else if(this.data?.OEMExcessPopup){
      this.getOemById(this.data.id);
    }
  }else
  this.allDropdownList()
  }
  allDropdownList(){
    this.partsListService.allPartDropdownList().subscribe((res) => {
      if (res.isSuccess) {
        this.getAllDropdown = res?.response;
         const isOEM = !!this.data?.OEMExcessPopup;
        this.allContactList = isOEM ? res.response.contactNameList: res.response.vendorContactList;
        this.fillCheckedList();
        this.formModel.expirationDate = this.formModel?.expirationDate ? this.stringToDateService.convertStringToDate(this.formModel?.expirationDate): '';

        const companyOrVendorId = isOEM ? this.formModel.companyId : this.formModel.vendorId;
        if (!companyOrVendorId) return;
        this.activityTabService.getContactList(companyOrVendorId).subscribe(res2 => {
          if (res2.isSuccess) {
            if (isOEM) {
              this.getAllDropdown.contactNameList = res2.response.contactList;
            } else {
              this.getAllDropdown.vendorContactList = res2.response.contactList;
            }
          }
        });
      }
    });

  }
  onKeydown(event: any, value: any) {
    const element = this.renderer.selectRootElement(value, true);
    if (event.key === "Enter") {
      element.focus();
    }
  }
  openAddEditPartModal(){
        const data = {}
        this.sendDataService.openModalPopup(AddEditPartComponent, data, 'Add Part', ModalPopupSize.LG ,'add-part-popup').then(
          (resultData) => {
            if (resultData?.confirm) {
                 this.partsListService.allPartDropdownList().subscribe((res) => {
                if (res.isSuccess) {
                  this.getAllDropdown = res?.response;
                  this.formModel.mpnId = resultData?.response?.response?.id;
                  this.onMpnGetbyId(this.formModel.mpnId)
                }
              });
            }
          }
        );
  }
    openAddEditMFRModal(){
      const data = {}
      this.sendDataService.openModalPopup(AddEditManufacturerComponent, data, 'Add', ModalPopupSize.MD, 'has-parent-popup').then(
        (resultData) => {
          if (resultData?.isSuccess) {
            this.partsListService.allPartDropdownList().subscribe((res) => {
            this.getAllDropdown = res?.response;
            this.formModel.mfrId = resultData?.response?.id;
          });
        }
        }
      );
    }

  inputValueEmit(event) {
    if (!this.getAllDropdown?.roHSList) {
      return;
    }
    this.getAllDropdown.roHSList = this.getAllDropdown.roHSList.map(item => {
      if (item.id === event.id) {
        return { ...item, isActive: event.isActive };
      }
      return item;
    });
    let rohsId =this.getAllDropdown?.roHSList?.filter((a) => a?.isActive === true) ??[];
      this.formModel = this.formModel??{}
      this.formModel.rohsId = rohsId;
  }

  inputValueCOOEmit(event) {
    if (!this.getAllDropdown?.countryList) {
      return;
    }
    this.getAllDropdown.countryList = this.getAllDropdown.countryList.map(item => {
      if (item.id === event.id) {
        return { ...item, isActive: event.isActive };
      }
      return item;
    });
    let cooId =this.getAllDropdown?.countryList?.filter((a) => a?.isActive === true) ??[];
      this.formModel = this.formModel??{}
      this.formModel.cooId = cooId;

  }

  fillCheckedList() {
    this.getAllDropdown?.roHSList?.map((gs) => {
      this.formModel?.rohsId?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropdown?.countryList?.map((gs) => {
      this.formModel?.cooId?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.filterCheckList.rohs_CheckList = this.formModel?.rohsId?.map((value) => value.name);
    this.filterCheckList.coo_CheckList = this.formModel?.cooId?.map((value) => value.name);
  }

addVendorPart(){
  this.formModel.expirationDate = this.formModel.expirationDate ? this.stringToDateService.dateConvertedToString(this.formModel.expirationDate): '';
  this.vplService.addVendorPart(this.formModel).subscribe({
    next:(res)=>{
    if (res.isSuccess) {
      this.toaster.success(res?.message);
        this.activeModal.close({ response: res, confirm: true });
      }},
    error: (err) => {
      console.log(err)
    }
  });
  }
  selectMpnMfrValueChange(event: any, source: 'mpn' | 'mfr'): void {
    if (event === ''){
      if (source == 'mpn') {
        this.formModel.mpnId = '';
      }else{
        this.formModel.mfrId = '';
      }
      return;
    } 
    if (source === 'mpn') {
      this.formModel.mpnId = event;
      const data = this.getAllDropdown.mpnList.find((x: any) => x.id === event);
      if (data?.extra1) {
        this.formModel.mfrId = data.extra1;
      }
      this.onMpnGetbyId(this.formModel.mpnId);
    } else if (source === 'mfr') {
      this.formModel.mfrId = event;
    }
  }

  onMpnGetbyId(id) {
    if (id) {
      this.partsListService.getPartInventoryById(id).subscribe({
        next: (res) => {
          if(res?.isSuccess){
            let data = res?.response;
            this.formModel.description = data?.description;
            this.formModel.standardPackagingId = data?.standardPackagingName;
            this.formModel.spq  = data?.spq;
            this.formModel.uomId = data?.uomName;
            this.formModel.moq = data?.moq;
            this.formModel.mountTypeId  = data?.mountTypeName;
            this.formModel.tempGradeId = data?.tempGradeName;
          }
        },
        error:(err)=>{
          console.log(err)
        }
      })
    }
    else{
      this.formModel.description = this.formModel.standardPackagingId =  this.formModel.spq = this.formModel.uomId =
      this.formModel.moq = this.formModel.mountTypeId  = this.formModel.tempGradeId ='';
    }
  }

 onChange(id:string , list:any,name:string){
  if(id == ''){
    this.data = this.data??{}
    this.data[name] = null
  }else{
    let type = list?.filter((a) => a?.id === id) ?? [];
    this.data = this.data??{}
    this.data[name] = type[0].name
  }
}

getContactList(id){
  if (id == '') {
    if(this.data?.OEMExcessPopup){
    this.formModel.contactId = '';
    this.getAllDropdown.contactNameList = this.allContactList;
    } else{
    this.formModel.vendorContactId = '';
    this.getAllDropdown.vendorContactList = this.allContactList;
    }
    return
  }
  this.activityTabService.getContactList(id).subscribe((res) => {
    if (res.isSuccess) {
      if(this.data?.OEMExcessPopup){
        this.formModel.contactId = '';
        this.getAllDropdown.contactNameList = res?.response?.contactList
      } else{
        this.formModel.vendorContactId = '';
        this.getAllDropdown.vendorContactList = res?.response?.contactList
      }
    }
  });
  }
  vendorPartById(id: string){
    this.vplService.getVendorPartById(id).subscribe((res)=>{
      if (res?.isSuccess) {
        this.formModel = res.response;
        this.allDropdownList()
        this.onMpnGetbyId(this.formModel?.mpnId);
      }
    });
   }
   addParts(){
    if (this.formModel?.id) {
      this.data?.OEMExcessPopup? this.updateOemPart() : this.updateVendorPart();
    } else {
      this.data?.OEMExcessPopup?this.addOEMPart():this.addVendorPart()
    }
  }
 
   updateVendorPart(){
    const formModel = this.formModel;
    this.formModel.expirationDate = this.formModel.expirationDate? this.stringToDateService.dateConvertedToString(this.formModel.expirationDate): '';
    this.vplService.getUpdateVendor(formModel).subscribe({
      next: (res)=>{
        if(res.isSuccess){
        this.toaster.success(res?.message);
        this.activeModal.close({ response: res,confirm: true });
      }
      },
      error :(err)=>{
        console.log(err);
      }
    });
  }
  addOEMPart(){
  this.formModel.expirationDate = this.formModel.expirationDate ? this.stringToDateService.dateConvertedToString(this.formModel.expirationDate): '';
  this.oemExcessService.addOemExcess(this.formModel).subscribe({
    next:(res)=>{
    if (res.isSuccess) {
      this.toaster.success(res?.message);
        this.activeModal.close({ response: res, confirm: true });
      }},
    error: (err) => {
      console.log(err)
    }
  });
  }

  getOemById(id: string){
   this.oemExcessService.getOemExcessById(id).subscribe((res)=>{
    if(res?.isSuccess){
      this.formModel = res.response;
       this.allDropdownList()
       this.onMpnGetbyId(this.formModel?.mpnId);
    }
    });
 }
  updateOemPart(){
    const formModel = this.formModel;
    this.formModel.expirationDate = this.formModel.expirationDate? this.stringToDateService.dateConvertedToString(this.formModel.expirationDate): '';
    this.oemExcessService.getUpdateOem(formModel).subscribe({
      next: (res)=>{
        if(res.isSuccess){
        this.toaster.success(res?.message);
        this.activeModal.close({ response: res,confirm: true });
      }
      },
      error :(err)=>{
        console.log(err);
      }
    });
  }
}
